/* eslint-disable @typescript-eslint/no-unused-vars-experimental */
import * as React from 'react';
import styled from 'styled-components';

const StyledProgressWrapper = styled.div<{ customWidth?: string }>`
  height: 8px;
  width: ${({ customWidth }) => customWidth || '100px'};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #5a5b61;
`;

const StyledProgressBar = styled.div<{
  currentPercent: number;
  barColor: string;
}>`
  height: 100%;
  width: ${({ currentPercent }) => currentPercent}%;
  background: ${({ barColor }) => barColor};
`;

export interface IPowerProgressBarProps {
  currentValue: number;
  maxValue: number;
  mediumLimitInPercent?: number;
  heightLimitInPercent?: number;
  customWidth?: string;
}

const PowerProgressBar: React.FunctionComponent<IPowerProgressBarProps> = props => {
  const {
    currentValue,
    maxValue,
    mediumLimitInPercent = 60,
    heightLimitInPercent = 80,
    customWidth
  } = props;

  const getBarProps = (): { color: string; percentValue: number } => {
    let color;
    const percentValue = (currentValue / maxValue) * 100;
    if (percentValue >= heightLimitInPercent) {
      color = '#D14020';
    } else if (percentValue >= mediumLimitInPercent) {
      color = '#DF692B';
    } else {
      color = '#94FFCA';
    }
    return { color, percentValue };
  };

  const { color, percentValue } = getBarProps();

  return (
    <StyledProgressWrapper customWidth={customWidth}>
      <StyledProgressBar currentPercent={percentValue} barColor={color} />
    </StyledProgressWrapper>
  );
};

export default PowerProgressBar;
